<template>
 <div role="main" >
  <form @keydown.enter.prevent="submitted" action="self">
   <div id="form-container" class="container-fluid px-0">
    <div class="layout-occupants">
      <layout-default :group="groupSegmentsDefault()" :pageData="pageData"></layout-default>
        <br>
       <!--NEW/Added Mortgage-->
    <div class="row no-gutters mt-1">
        <div class="col-12 py-2 pl-2 product-section-heading text-white rounded-top">
        <div role="heading" aria-level="2">Manually add Scheduled Item(s) to the policy.</div>
        </div>
        <div class="col-12 py-2 shadow-sm rounded-bottom">
        <!--added Mortgage -->
        <div class="d-inline-block w-100">
             <button class="add-button btn btn-outline-success px-1 wsn select list-item px-3"
                tabindex="0" @keydown.enter.prevent.stop="addNewRuleForProperty(UrlAPI, 'coverage')"
                @click.prevent="addNewRuleForProperty(UrlAPI, 'coverage')" v-if="isInvisible()&&!isPolicyBound()">
                <icon name="plus-circle" scale="1.1" class="d-block mx-auto float-left"></icon>
                <div class="smaller-font-content polk-veh-lbl float-left text-left d-block pl-1">Add Scheduled Items</div>
            </button>
            <div v-for="(vitem, ndKey) in pageFieldsArray" class="list-item" :key="ndKey+'_non_add_sch'">
            <button type="button"  class="vd-btn btn pvd-btn btn x-3 wsn select list-item" tabindex="0" :key="ndKey+'_non_add_button'">
                <div class="smaller-font-content polk-veh-lbl float-left text-left d-block pl-1">
                 {{ getAccordianLabel(pageFieldsArray, ndKey) }}</div>
                <a href="JavaScript:void(0);" v-if="!isPolicyBound()"
                @keydown.enter.prevent.stop="promptDeleteSection(`remove-claim-modal_${ndKey}`)"
                @click.stop="promptDeleteSection(`remove-claim-modal_${ndKey}`)" class="delete"
                aria-label="remove Coverage" tabindex="0"
                ></a></button>
               <b-modal :ref="`remove-claim-modal_${ndKey}`" hide-header hide-footer hide-header-close no-enforce-focus>
              <Trapclaim :group="`remove-modal`">
                <div class="remove-confirmation-box">
                  <div class="remove-modal-message mb-3">
                    <div>Are you sure you want to remove this Scheduled Item?</div>
                  </div>
                  <div class="remove-modal-sep mt-1 mb-1"></div>
                  <div class="remove-btn-box">
                    <b-button class="mt-3 remove-btn-cancel remove-cust-btn" block
                    @keydown.enter.prevent.stop="closeModal(`remove-claim-modal_${ndKey}`)"
                    @keydown.space.prevent.stop="closeModal(`remove-claim-modal_${ndKey}`)" @click.prevent.stop="closeModal(`remove-claim-modal_${ndKey}`)">Cancel</b-button>
                    <b-button class="mt-3 remove-btn-confirm remove-cust-btn" block @keydown.enter.prevent.stop="deleteSection(vitem, ndKey)"
                    @keydown.space.prevent.stop="deleteSection(vitem, ndKey)" @click.prevent.stop="deleteSection(vitem, ndKey)">
                      Remove</b-button>
                  </div>
                </div>
              </Trapclaim>
            </b-modal>
           </div>
        </div>
       </div>
      </div>
      <!--ADD MORE SCHEDULE ITEMS SECTION ENDS-->

      <template>
      <!-- Top scroll bar START -->
      <!-- This is for the top scroll bar. It will match the width of the actual carousel -->
      <div id="carousel-vehicle-top-scrollbar" ref="carousel-vehicle-top-scrollbar" class="scrolling-wrapper pb-2 bg-white">
        <div  v-for="(vitem, vkey) in pageFieldsArray" :key="vkey" class="cardItem col-md-3">
        </div>
      </div>
      <!-- Top scroll bar END -->

      <!-- Column headings START -->
      <div id="carousel-coverage-headings" ref="carousel-coverage-headings" class="scrolling-wrapper pt-3 bg-white">
        <div v-for="(vitem, k) in pageFieldsArray" :key="k"  class="cardItem col-md-3">
          <div v-bind:id="'SchItem_'+k" class="form-row py-2 pl-3 mx-0 product-section-heading text-white rounded-top h-100">
            <div class="col p-0">
              <div>
                  <div role="heading" aria-level="4">{{ getAccordianLabel(pageFieldsArray, k) }}</div>
                  <a v-if="!isPolicyBound()" href="javascript:void(0);" class="delete"
                    @keydown.enter.prevent.stop="promptDeleteSection(`remove-claim-modal_${k}`)"
                    @keydown.space.prevent.stop="promptDeleteSection(`remove-claim-modal_${k}`)"
                    @click.prevent="promptDeleteSection(`remove-claim-modal_${k}`)"
                    ></a>
              </div>
            </div>
          </div>
            <!--  remove modal -->
          <div>
            <b-modal :ref="`remove-claim-modal_${k}`" hide-header hide-footer hide-header-close no-enforce-focus>
              <Trapclaim :group="`remove-modal`">
                <div class="remove-confirmation-box">
                  <div class="remove-modal-message mb-3">
                    <div>Are you sure you want to remove this Scheduled Item?</div>
                  </div>
                  <div class="remove-modal-sep mt-1 mb-1"></div>
                  <div class="remove-btn-box">
                    <b-button class="mt-3 remove-btn-cancel remove-cust-btn" block
                    @keydown.enter.prevent.stop="closeRemoveModalProperty(`remove-claim-modal_${k}`)"
                    @keydown.space.prevent.stop="closeRemoveModalProperty(`remove-claim-modal_${k}`)" @click="closeRemoveModalProperty(`remove-claim-modal_${k}`)">Cancel</b-button>
                    <b-button class="mt-3 remove-btn-confirm remove-cust-btn" block @keydown.enter.prevent.stop="deleteSection(vitem, `remove-claim-modal_${k}`)"
                    @keydown.space.prevent.stop="deleteSection(vitem, `remove-claim-modal_${k}`)" @click="deleteSection(vitem, `remove-claim-modal_${k}`)">
                      Remove</b-button>
                  </div>
                </div>
              </Trapclaim>
            </b-modal>
          </div>
        </div>
      </div>
      <!-- Column headings END -->

       <div class="container-fluid" style="margin-top: 0">
        <div id="carousel-vehicle" ref="carousel-vehicle" class="row scrolling-wrapper pb-3">
          <div v-for="(vitem, vkey) in pageFieldsArray" :key="vkey"  class="cardItem col-md-3 mb-3">
              <div class="form-row mx-0 pt-3 accordPanel shadow-sm rounded-bottom">
                <div class="col-12 px-0">
                  <!--VEHICLE SECTION HEADER-->
                  <!--START VEHICLE SECTION CONTAINER-->
                  <div class="form-row ml-3 mr-0">
                    <div class="col-12 px-0">
                      <div>
                     <form-block v-for="(subItem, subKey) in vitem" :key="subKey+'_sch_item'" :formdata='subItem'
                        :ref='subItem.field_name' :formIndex="vkey" class="form-group">
                     </form-block>
                     </div>
                    </div>
                  </div>
                 <div class="form-row py-3 mx-0 mt-4 product-section-heading  text-white rounded-bottom">
                 <div class="removedv col p-0 text-right mr-3 smaller-font-content">
                   <div>
                    <a href="javascript:void(0);" class="text-white" v-if="!isPolicyBound()"
                      @keydown.enter.prevent.stop="promptDeleteSection(`remove-claim-modal_${vkey}`)"
                      @keydown.space.prevent.stop="promptDeleteSection(`remove-claim-modal_${vkey}`)"
                      @click.prevent="promptDeleteSection(`remove-claim-modal_${vkey}`)"
                      >Remove</a>
                     <!-- <div role="heading" aria-level="4">Remove</div>  -->
                   </div>
                </div>
          </div>
        </div>
        </div>
        </div>
    </div>
    </div>
    </template>
    <!-- <LayoutPropHorizontal :group="groupSegmentsHorizontal('Coverage Details')" :pageData="pageData"></LayoutPropHorizontal> -->
    <div class="d-inline-block w-100">
        <button class="add-button btn btn-outline-success px-1 wsn select list-item px-3"
                tabindex="0" @keydown.enter.prevent.stop="addNewRuleForProperty(UrlAPI, 'coverage')"
                @click.prevent="addNewRuleForProperty(UrlAPI, 'coverage')" v-if="isInvisible() &&!isPolicyBound()">
                <icon name="plus-circle" scale="1.1" class="d-block mx-auto float-left"></icon>
                <div class="smaller-font-content polk-veh-lbl float-left text-left d-block pl-1">Add Scheduled Item</div>
        </button>
     </div>
    </div>
  </div>
   <!-- View body END -->
  </form>
</div>
</template>

<script>
/* eslint-disable */
import { rulesMixin } from '@/mixins/rulesMixin';
import { pageMixin } from '@/mixins/pageMixin';
import FormBlock from '../FormBlock';
import LayoutPropHorizontal from '@/components/presentational/layouts/LayoutPropHorizontal';
import LayoutDefault from '@/components/presentational/layouts/LayoutDefault';
import rulesAPI from '@/services/postData';
import Trapclaim from 'vue-focus-lock';
import axios from '../../../axios-config';
import commonService from '../../../services/common';

export default {
  props: ['group', 'pageData', 'sectionTitles','pageMixin'],
  inject: ['$validator'],
  mixins: [rulesMixin],
   data() {
    return {
      allSections: [],
      allFields: [],
      UrlAPI:'',
      pageFieldsArray:[],
    };
  },
  components: {
    LayoutPropHorizontal,
    LayoutDefault,
    Trapclaim,
    FormBlock,
  },
 mounted(){
   const carouselVehicleTopScrollbar = document.getElementById('carousel-vehicle-top-scrollbar');
    const carouselVehicle = document.getElementById('carousel-vehicle');
    const carouselVehicleHeadings = document.getElementById('carousel-coverage-headings');
    carouselVehicleTopScrollbar.onscroll = () => {
      carouselVehicle.scrollLeft = carouselVehicleTopScrollbar.scrollLeft;
      carouselVehicleHeadings.scrollLeft = carouselVehicleTopScrollbar.scrollLeft;
    };
    carouselVehicle.onscroll = () => {
      carouselVehicleTopScrollbar.scrollLeft = carouselVehicle.scrollLeft;
      carouselVehicleHeadings.scrollLeft = carouselVehicle.scrollLeft;
    };
    carouselVehicleHeadings.onscroll = () => {
      carouselVehicleTopScrollbar.scrollLeft = carouselVehicleHeadings.scrollLeft;
      carouselVehicle.scrollLeft = carouselVehicleHeadings.scrollLeft;
    };

    // TODO: Don't check user agent since it is not always reliable
    // Hides horizontal scroll bar on column headings
    if (navigator.userAgent.toLowerCase().indexOf('firefox') !== -1) {
      carouselVehicleHeadings.classList.add('hide-x-scroll');
    }
  const sectiontosend='Coverage Details';
  this.populatePageData();
  this.UrlAPI="/rules/AddNewPropertyScheduledItem/QTE_PRP_SCH__Sch",
  this.groupSegmentsHorizontal();
  this.allSections= Object.keys(this.group).filter(section=>{
        if(section!==sectiontosend)
          return section;
      });
 },

  methods: {
    isPolicyBound() {
      return (this.pageData.quote_summary && this.pageData.quote_summary.quote_status === 'Bound'); // TODO: Use config values
    },
    isInvisible()
    {
     if (this.pageFieldsArray.length<=24)
     return true;
     else
     return false;
    },
     closeModal(sectionModal) {
          
      this.$refs[sectionModal][0].hide();
    },
     getAccordianLabel(vData, vKey) {
      return vData[vKey][0].section;
    },
    /**
     * Returns only the sections in the group whose index is in `sectionTitles`.
     */
     populatePageData() {
      this.allFields = this.pageData.fields;
      let allSections = Object.keys(this.group);
      let sectionsToSend= allSections.filter(section=>{
        if(section!=='Coverage Details')
          return section;
      });
      let filterFields=this.allFields.filter(el => 
              sectionsToSend.includes(el.section));
        for (let v = 0; v < filterFields.length; v += 1) {
        const currentSch = filterFields[v].index;
        if (!isNaN(currentSch)) {
          if (!this.pageFieldsArray[currentSch]) {
            this.pageFieldsArray.push(currentSch);
            this.pageFieldsArray[currentSch] = [];
          }
          this.pageFieldsArray[currentSch].push(filterFields[v]);
        }
        
      }
      return this.pageFieldsArray;
     },
    groupSegmentsDefault(){
    const groupSegmentsDefault = [];
    groupSegmentsDefault['Coverage Details']=this.group['Coverage Details'];
    return groupSegmentsDefault;
    },
    groupSegmentsHorizontal(sectiontoRemove) {
     const groupSegmentsHorizontal = [];
    let allSections = Object.keys(this.group);
     let sectionsToSend= allSections.filter(section=>{
        if(section!==sectiontoRemove)
          return section;
      });
      sectionsToSend.forEach((element) => {
        groupSegmentsHorizontal[element]=this.group[element];
       });
       
      return groupSegmentsHorizontal;
    },
     promptDeleteSection(sectionModal) {
      this.$refs[sectionModal][0].show();
    },
     deleteSection(section, schIndex) {
      const pageData = this.$store.state.updatePageData.pageData;
      this.$refs[`remove-claim-modal_${schIndex}`][0].hide();
      axios.post(
        `/rules/RemovePropertyScheduledItem/QTE_PRP_SCH_${schIndex}_Sch`,// API endpoint URL
        {
          fields: commonService.getFormData(this.pageData), // All of the current `pageData` fields
          page_name: this.pageData.page_name, // Current `pageData` `page_name`
          session_id: this.$store.getters.getSessionID, // Current Session ID
        },
    ).then(() => {
        // TODO: Update API to respond with which fields to remove, and remove those
        const timeStamp = new Date().getTime();
        this.$router.push({ path: 'coverage' + '?' + timeStamp });
      }).catch((error) => {
        // TODO: Use response (data or http code) to evaluate error
        window.console.warn('An error occurred while requesting a section button post:', error);
        gtag('event', 'exception', {
          description: 'Error requesting section button quote',
          fatal: false, // set to true if the error is fatal
        });
      });
    },
  },
};
</script>
<style>
vd-btn.list-item .delete{
    display: inline-block;
    position: absolute;
    right: -10px;
    top: -10px;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    line-height: 1em;
    cursor: pointer;
}
.list-item{
    display: inline-block;
    width: auto;
    height: auto;
    min-height: auto;
    float: none;
    margin: 0.25rem
}
.add-button{
    text-transform: initial;
}
.scrolling-wrapper {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
}

#carousel-coverage-headings {
    -ms-overflow-style: none;
}

#carousel-coverage-headings::-webkit-scrollbar {
    display: none;
}

.scrolling-wrapper .cardItem {
  flex: 0 0 auto;
}

.scrolling-wrapper::-webkit-scrollbar {
  width: 20px;
}

.scrolling-wrapper::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
  background: #FFFFFF;
}

.scrolling-wrapper {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
}

.scrolling-wrapper .cardItem {
  flex: 0 0 auto;
}

.scrolling-wrapper .cardItem.col-md-3 {
  max-width: 400px !important;
  padding: 0 0.5rem !important;
}

#carousel-coverage-headings .cardItem,
#form-container.fixed-top.fixed-to-nav {
  background: rgba(255, 255, 255, 0);
}

.list-item {
  display: inline-block;
  width: auto;
  height: auto;
  min-height: auto;
  float: none;
  margin: 0.25rem 0.25rem;
}

.vd-btn.list-item .delete{
  display: inline-block;
  position: absolute;
  right: -10px;
  top: -10px;
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  line-height: 1em;
  cursor: pointer;
}

.vehicle-check-polk {
  display: block;
  position: absolute;
  right:-13px;
  bottom: -3px;
  width: 20px;
  height: 20px;
}

.hide-x-scroll {
  overflow-x: hidden;
}

/***header/footer information blurb***/
@media all and (max-width: 992px) {
  .alert.alert-primary{
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/presentational/layouts/LayoutCoverage.vue?3e97afc5